










import { Component, Prop, Vue } from 'vue-property-decorator';
import { ImageLinkDto, LinkDto, PageTeaserDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import CmsImageLink from '@/views/cms/snippet/CmsImageLink.vue';

@Component({
  components: {CmsImageLink, CmsLink},
})
export default class PageTeaser extends Vue {
  @Prop({required: true})
  public readonly model!: PageTeaserDto;

  get fakeLink(): LinkDto {
    return {
      caption: this.model.title,
      target: this.model.path,
      newTab: false,
    };
  }

  get fakeImageLink(): ImageLinkDto | null {
    if (!this.model.teaserImagePath) {
      return null;
    }
    return Object.assign({imagePath: this.model.teaserImagePath}, this.fakeLink);
  }
}
